export const storeUTMParams = () => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined')
    return

  const params = new URLSearchParams(window.location.search)
  const keys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'vote_source',
  ]

  keys.forEach((key) => {
    const value = params.get(key)
    if (value) {
      sessionStorage.setItem(key, value)
    }
  })
}

export const getStoredUTMParams = () => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return {
      utmSource: '',
      utmMedium: '',
      utmCampaign: '',
      utmContent: '',
      utmTerm: '',
      voteSource: '',
    }
  }

  return {
    utmSource: sessionStorage.getItem('utm_source') || '',
    utmMedium: sessionStorage.getItem('utm_medium') || '',
    utmCampaign: sessionStorage.getItem('utm_campaign') || '',
    utmContent: sessionStorage.getItem('utm_content') || '',
    utmTerm: sessionStorage.getItem('utm_term') || '',
    voteSource: sessionStorage.getItem('vote_source') || '',
  }
}

export const getSafeURLParams = () => {
  if (typeof window === 'undefined') {
    return new URLSearchParams()
  }
  return new URLSearchParams(window.location.search)
}

export const getUTMParamWithFallback = (paramKey, formData = {}) => {
  const urlParams = getSafeURLParams()
  const storedParams = getStoredUTMParams()

  const paramMap = {
    utmCampaign: { url: 'utm_campaign', stored: 'utmCampaign' },
    utmContent: { url: 'utm_content', stored: 'utmContent' },
    utmMedium: { url: 'utm_medium', stored: 'utmMedium' },
    utmSource: { url: 'utm_source', stored: 'utmSource' },
    utmTerm: { url: 'utm_term', stored: 'utmTerm' },
  }

  const mapping = paramMap[paramKey]
  if (!mapping) return ''

  return (
    formData[paramKey] ||
    urlParams.get(mapping.url) ||
    storedParams[mapping.stored] ||
    ''
  )
}

export const getVoteSourceWithFallback = () => {
  const urlParams = getSafeURLParams()
  const storedParams = getStoredUTMParams()

  const rawVoteSource =
    urlParams.get('vote_source') || storedParams.voteSource || ''

  const voteSourceMap = {
    web: 'Web',
    tvos: 'tvOS',
    roku: 'Roku',
    androidtv: 'Android TV',
    firetv: 'Android TV',
    android: 'Android',
    android_mobile: 'Android',
    ios_mobile: 'iOS',
    ios: 'iOS',
  }

  return voteSourceMap[rawVoteSource] || rawVoteSource
}
